<template>
  <v-form ref="form" v-model="valid">
    <MobileNumberValidator v-model="profile.mobileNumber" @validate="$refs['form'].validate()">
      <v-text-field
        slot-scope="{ validator }"
        label="Mobile Number"
        :value="validator.mobileNumber"
        :color="themes.candidate.light.input"
        @input="validator.updateMobileNumber"
        @blur="submit"
        @focus="focused = true"
        :rules="validator.rules.mobileNumber"
        :placeholder="validator.placeholder"
        :mask="validator.mask"
        :hint="`eg. ${validator.placeholder}`"
        :readonly="!validator.countryCode"
        type="tel"
      >
        <v-autocomplete dense
          slot="prepend" style="top: -1.7rem; height: 1rem;"
          v-model="validator.countryCode"
          :color="themes.candidate.light.input"
          @input="validator.updateCountryCode"
          @blur="submit"
          :items="validator.countries"
          item-text="name" item-value="code"
          :filter="validator.countriesFilter"
          :rules="validator.rules.code"
          placeholder="Country"
          attach
        >
          <template slot="selection" slot-scope="{ item: country }">
            <v-list-tile-avatar size="22px" style="padding: 0.5rem 1rem;">
              <img
                :class="`flag-icon-background flag-icon-squared flag-icon-${country.code.toLowerCase()}`"
                style="padding: 16px"
              />
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>+ {{ validator.getCallingCode(country.code) }}</v-list-tile-title>
            </v-list-tile-content>
          </template>
          <template slot="item" slot-scope="{ item: country }">
            <v-list-tile-avatar size="22px">
              <img
                :class="`flag-icon-background flag-icon-squared flag-icon-${country.code.toLowerCase()}`"
                style="padding: 16px"
              />
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>+ {{ validator.getCallingCode(country.code) }}</v-list-tile-title>
            </v-list-tile-content>
          </template>
        </v-autocomplete>
      </v-text-field>
    </MobileNumberValidator>
  </v-form>
</template>

<script>
// Components
import MobileNumberValidator from '@/components/candidate/MobileNumberValidator'

// Vue Component
export default {
  props: ['value'],

  components: { MobileNumberValidator },

  data() {
    return {
      valid: this.value && this.value.length > 0,
      // Loading indicator
      loading: false,
      // Model (object sent to API)
      profile: {
        mobileNumber: this.value,
      },
      // UX Improvements
      focused: false,
    }
  },

  methods: {
    submit() {
      this.focused = false
      const isValid = this.$refs.form.validate()
      if (isValid && this.value !== this.profile.mobileNumber) {
        this.loading = true
        this.$store
          .dispatch('candidate/profile/update', this.profile)
          .then(() => (this.loading = false))
      }
    },
  },
}
</script>
